var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { memo, useContext } from 'react';
import { extractSupportProps } from '@snack-uikit/utils';
import { ELEMENT_TYPE, ITEM_RENDER_MODE } from '../../constants';
import { BreadcrumbsContext } from '../../context';
import { getTestId } from '../../utils';
import { CrumbsTypography } from '../CrumbsTypography';
import styles from './styles.module.css';
const ELLIPSIS_LABEL_LENGTH = 8;
export const Crumb = memo(function Crumb(_a) {
    var { minWidth: minWidthProp = 0, current = false, renderMode, className, item: { label: labelProp, shortLabel, icon: Icon, id, onClick, href }, useIconOnly: useIconOnlyProp } = _a, rest = __rest(_a, ["minWidth", "current", "renderMode", "className", "item", "useIconOnly"]);
    const { hidden, size, testId } = useContext(BreadcrumbsContext);
    const isLabelShouldBeEllipse = hidden && labelProp.length > ELLIPSIS_LABEL_LENGTH;
    const label = isLabelShouldBeEllipse && renderMode === ITEM_RENDER_MODE.Ellipsis ? `${labelProp.substring(0, 4)}...` : labelProp;
    const useIconOnly = Boolean(Icon && useIconOnlyProp);
    const minWidth = minWidthProp && renderMode === ITEM_RENDER_MODE.Ellipsis ? minWidthProp : 'auto';
    const dataAttributes = {
        'data-render-mode': renderMode,
        'data-current': current,
        'data-hidden': hidden,
        'data-size': size,
        'data-id': id,
    };
    const content = (_jsxs(_Fragment, { children: [Icon && (_jsx("div", { className: styles.icon, children: _jsx(Icon, { size: 16 }) })), !useIconOnly && (_jsx(CrumbsTypography, { size: size, className: styles.label, children: renderMode === ITEM_RENDER_MODE.ShortLabel ? shortLabel : label }))] }));
    const tabIndex = hidden ? { tabIndex: -1 } : {};
    const title = renderMode === ITEM_RENDER_MODE.Ellipsis ? label : '';
    let crumb = null;
    if (href) {
        crumb = (_jsx("a", Object.assign({ className: styles.crumb, onClick: onClick, href: href, "aria-label": useIconOnly ? label : undefined, "data-clickable": true }, dataAttributes, tabIndex, { children: content })));
    }
    else if (onClick) {
        crumb = (_jsx("button", Object.assign({ type: 'button', title: title, onClick: onClick, className: styles.crumb, "aria-label": useIconOnly ? label : undefined, "data-clickable": true }, dataAttributes, tabIndex, { children: content })));
    }
    else {
        crumb = (_jsx("div", Object.assign({ className: styles.crumb }, dataAttributes, { children: content })));
    }
    return (_jsx("li", Object.assign({}, extractSupportProps(rest), dataAttributes, { "data-test-id": getTestId('crumb', testId), className: cn(styles.wrapper, className), "data-element-type": ELEMENT_TYPE.Item, style: { minWidth }, title: title, children: crumb })));
});
